// extracted by mini-css-extract-plugin
export default {"video":"youtube-modal_video__IEf54","close":"youtube-modal_close__bPWad","show":"youtube-modal_show__DS3Gw"};